import * as React from 'react';
import { useAppDispatch } from 'store/hooks';
import { removeAssetIdToFetchRealTimePrices, setAssetIdToFetchRealTimePrices } from 'actions/invest';
const useGetRealTimePrices = (assetId) => {
    const dispatch = useAppDispatch();
    React.useEffect(() => {
        if (assetId) {
            dispatch(setAssetIdToFetchRealTimePrices(assetId));
            return () => {
                dispatch(removeAssetIdToFetchRealTimePrices(assetId));
            };
        }
        return () => { };
    }, [assetId]);
};
export default useGetRealTimePrices;
